import ServerBaseError from './ServerBaseError';

export default class ServerNotFoundError extends ServerBaseError {
  constructor(message = 'Requested data was not found', showErrorPage = false) {
    super(message, showErrorPage);
  }
}
